import { useFormContext } from 'react-hook-form';
import {
  ServiceActivationUpdate,
  ServiceType,
} from '../../../../../codegen/vehicles';
import { remove } from 'lodash';
import { appConfiguration } from '../../../../../configuration/appConfiguration';
import { PaymentMethod, Vehicle } from '../../../../../models';

export type ServiceConfigurationForm = {
  serviceActivations: {
    [serviceType: string]: ServiceActivationUpdate;
  };
  paymentMethods: PaymentMethod[];
};

export const createServiceConfigurationFormData = (vehicle?: Vehicle) => {
  const formData: ServiceConfigurationForm = {
    serviceActivations: {},
    paymentMethods: [],
  };

  appConfiguration.supportedServiceTypes.forEach((serviceType: string) => {
    if (!formData.serviceActivations[serviceType]) {
      const serviceActivation = vehicle?.serviceActivations?.find(
        (s) => s.serviceType === (serviceType as ServiceType),
      );

      if (serviceActivation) {
        formData.serviceActivations[serviceType] = {
          ...serviceActivation,
          enabled: true,
        };
      } else {
        formData.serviceActivations[serviceType] = {
          enabled: true,
          serviceType: serviceType as ServiceType,
          paymentMethodAssignments: [],
        };
      }
    }
  });

  formData.paymentMethods = vehicle?.paymentMethods || [];
  return formData;
};

export const useServiceConfigurationFormContext = () => {
  const form = useFormContext<ServiceConfigurationForm>();

  const getServiceActivations = () => {
    return form.getValues('serviceActivations');
  };

  const removePaymentMethodFromServices = (
    serviceTypes: ServiceType[],
    paymentMethodId: string,
  ) => {
    serviceTypes.forEach((serviceType) => {
      const serviceActivation = form.getValues(
        `serviceActivations.${serviceType}`,
      );
      form.setValue(`serviceActivations.${serviceType}`, {
        ...serviceActivation,
        paymentMethodAssignments: [],
      });

      form.setValue(`serviceActivations.${serviceType}.enabled`, false);
    });

    removePaymentMethod(paymentMethodId);
  };

  const removePaymentMethod = (paymentMethodId: string) => {
    const paymentMethods = form.getValues('paymentMethods');
    remove(paymentMethods, { id: paymentMethodId });
    form.setValue('paymentMethods', paymentMethods);
  };

  const getPaymentMethods = () => {
    return form.getValues('paymentMethods');
  };

  return {
    ...form,
    getServiceActivations,
    removePaymentMethod,
    removePaymentMethodFromServices,
    getPaymentMethods,
  };
};
